import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import type { AdminServicesStateData } from "@/types/catalog"

export type AdminServiceOptionsState = {
  data: AdminServicesStateData
  error: string | null
}

export const adminServiceOptionsInitialState: AdminServiceOptionsState = {
  data: {
    services: [],
    pagination: {
      pageNumber: 1,
      pageSize: 10,
      totalElements: 0,
      totalPages: 0,
    },
  },
  error: null,
}

const slice = createSlice({
  name: "adminServiceOptions",
  initialState: adminServiceOptionsInitialState,
  reducers: {
    setAdminServiceOptionsAction(state, { payload }: PayloadAction<AdminServicesStateData>) {
      state.data = payload
      state.error = null
    },
    appendAdminServiceOptionsAction(state, { payload }: PayloadAction<AdminServicesStateData>) {
      const serviceMap = new Map(state.data.services.map((service) => [service.id, service]))

      payload.services.forEach((service) => {
        serviceMap.set(service.id, service)
      })

      state.data = {
        services: Array.from(serviceMap.values()),
        pagination: payload.pagination,
      }
      state.error = null
    },
    setAdminServiceOptionsErrorAction(state, { payload }: PayloadAction<string | null>) {
      state.error = payload
    },
  },
})

export const {
  appendAdminServiceOptionsAction,
  setAdminServiceOptionsAction,
  setAdminServiceOptionsErrorAction,
} = slice.actions
export default slice.reducer
